<template>
    <div>
        <div v-if="showAssignmentWarningPopup" class="assignment-warning-overlay" @click="cancelAssignmentWarning">
            <div class="assignment-warning-modal" @click.stop>
                <h3>Lineup Assignment Warning</h3>
                <p>You are not assigned to that job on that date. Are you sure you want to proceed?</p>

                <div class="assignment-warning-actions">
                    <button type="button" class="btn btn-save" @click="continueAfterAssignmentWarning">
                        Continue
                    </button>

                    <button type="button" class="btn btn-secondary" @click="cancelAssignmentWarning">
                        Cancel
                    </button>
                </div>
            </div>
        </div>

        <div class="card-body">

            <b-row class="my-1" style="margin-bottom:13px !important;">
                <b-col sm="12">
                    <b-form-checkbox-group id="checkboxes-4">
                        <b-form-checkbox value="1" unchecked-value="0" class="form-checkbox" size="lg"
                            v-model="timesheetData.rework">
                            Rework?
                        </b-form-checkbox>
                    </b-form-checkbox-group>
                </b-col>
            </b-row>

            <div class="clearfix"></div>

            <b-row class="my-1">
                <b-col sm="2">
                    <label>Time In<span style="color:red;">*</span></label>
                </b-col>

                <b-col sm="10">
                    <datetime type="datetime" use12-hour :min-datetime="initDate.inStart" :max-datetime="initDate.inEnd"
                        v-model="timesheetData.timeIn" @input="calculateTotalHours" />
                </b-col>
            </b-row>

            <b-row class="my-1">
                <b-col sm="2">
                    <label>Time Out<span style="color:red;">*</span></label>
                </b-col>

                <b-col sm="10">
                    <datetime type="datetime" use12-hour :min-datetime="initDate.outStart"
                        :max-datetime="initDate.outEnd" v-model="timesheetData.timeOut" @input="calculateTotalHours" />
                </b-col>
            </b-row>

            <b-row class="my-1">
                <b-col sm="2">
                    <label>Break(Mins)</label>
                </b-col>

                <b-col sm="10">
                    <b-form-input class="shadow-sm p-3 mb-1 bg-white rounded" v-model="timesheetData.break"
                        autocomplete="off" @keyup="calculateTotalHours" />
                </b-col>
            </b-row>

            <b-row class="my-1">
                <b-col sm="2">
                    <label>Total Hours</label>
                </b-col>

                <b-col sm="10">
                    <b-form-input disabled class="shadow-sm p-3 mb-1 bg-white rounded"
                        v-model="timesheetData.totalHour" />
                </b-col>
            </b-row>

            <b-row class="my-1">
                <b-col sm="2">
                    <label>Job<span style="color:red;">*</span></label>
                </b-col>

                <b-col sm="10">

                    <vue-bootstrap-typeahead :minMatchingChars="1" :maxMatches="100" class="shadow-sm"
                        placeholder="Search Job" ref="job" v-model="timesheetData.job" :serializer="item => item.value"
                        :data="job_option" @hit="selectedJob" />

                </b-col>
            </b-row>

            <b-row class="my-1">
                <b-col sm="2">
                    <label>Task Category<span style="color:red;">*</span></label>
                </b-col>

                <b-col sm="10">

                    <b-form-select class="shadow-sm mb-1" v-model="timesheetData.category" :options="task_option" />

                </b-col>
            </b-row>

            <b-row class="my-1">

                <b-col sm="2">
                    <label>Description</label>
                </b-col>

                <b-col sm="10">

                    <b-form-textarea id="textarea-small" size="sm" class="shadow-sm p-3 mb-3 bg-white rounded"
                        v-model="timesheetData.description" />

                </b-col>

            </b-row>

            <div class="clearfix"></div>

            <div class="form-group" style="text-align:center;margin-top:8px;">
                <button type="button" class="btn btn-save shadow" :disabled="isSaved" @click="saveTimesheet">
                    Save
                </button>
            </div>

        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

export default {

    name: 'AddTimesheetModal',

    components: {
        Datetime,
        VueBootstrapTypeahead
    },
    props: {
        prefillJobId: {
            type: [Number, String],
            default: null
        },
        prefillJobName: {
            type: String,
            default: ''
        },
        pageName: {
            type: String,
            default: 'Add Timesheet Modal'
        }
    },
    data() {

        return {

            constants: CommonConstants,

            moment,

            pastDateStart: '',
            pastDateEnd: '',

            task_option: [],

            job_option: [],

            initDate: {
                inStart: '',
                inEnd: '',
                outStart: '',
                outEnd: ''
            },

            isSaved: false,

            showAssignmentWarningPopup: false,

            pendingCreatePostData: null,

            timesheetData: {

                timeIn: moment().format(),

                timeOut: moment().format(),

                break: 0,

                totalHour: 0,

                job: '',

                category: '',

                description: '',

                rework: []
            }

        }

    },

    mounted() {

        this.getFormData()
        this.job_option = JSON.parse(localStorage.getItem('jobs_status_json'))
        this.applyPrefillJob();
    },
    watch: {
        job_option() {
            this.ensurePrefillJobOption();
        }
    },
    methods: {
        // getFormData() {
        //     let self = this;

        //     let header = {
        //         headers: {
        //             'Content-type': 'application/json',
        //             token: localStorage.getItem('token')
        //         }
        //     };

        //     axios
        //         .get(self.constants.api_url + 'timesheet/add', header)
        //         .then(function (response) {
        //             let res = response.data.data;

        //             self.pastDateStart = res.period_start;
        //             self.pastDateEnd = res.period_end;

        //             self.initDate.inStart = moment(res.period_start)
        //                 .subtract(1, 'days')
        //                 .format('YYYY-MM-DD');

        //             self.initDate.inEnd = moment(res.period_end)
        //                 .add(1, 'days')
        //                 .format('YYYY-MM-DD');

        //             self.initDate.outStart = res.period_start;

        //             self.initDate.outEnd = moment(res.period_end)
        //                 .add(2, 'days')
        //                 .format('YYYY-MM-DD');

        //             self.task_option = [];

        //             for (var d of res.task_select) {
        //                 self.task_option.push({
        //                     text: d.value,
        //                     value: d.id
        //                 });
        //             }

        //             axios
        //                 .get(self.constants.api_url + 'jobs-status-input-ajax', header)
        //                 .then(function (res) {
        //                     let jobs = [];

        //                     for (var d of res.data.data) {
        //                         jobs.push({
        //                             id: d.job_id,
        //                             value:
        //                                 d.description.toString().substring(2) +
        //                                 ' - ' +
        //                                 d.title
        //                         });
        //                     }

        //                     localStorage.setItem(
        //                         'jobs_status_json',
        //                         JSON.stringify(jobs)
        //                     );

        //                     self.job_option = jobs;
        //                 });
        //         })
        //         .catch(function (e) {
        //             Vue.$toast.error(e, {
        //                 position: 'top'
        //             });
        //         });
        // },

        applyPrefillJob() {
            if (!this.prefillJobId) return;
            this.timesheetData.job = this.prefillJobId.toString();
            this.ensurePrefillJobOption();
            this.$nextTick(() => {
                if (this.$refs.job) {
                    this.$refs.job.inputValue = this.prefillJobName;
                }
            });
        },
        ensurePrefillJobOption() {
            if (!this.prefillJobId) return;
            const exists = this.job_option.some(j => j.id == this.prefillJobId);
            if (!exists) {
                this.job_option.push({ id: this.prefillJobId, value: this.prefillJobName });
            }
        },
        getFormData() {
            let self = this;

            let header = {
                headers: {
                    "Content-type": "application/json",
                    token: localStorage.getItem("token")
                }
            };

            axios.get(self.constants.api_url + "timesheet/add", header)
                .then(function (response) {
                    if (response.data.flag !== true) {
                        Vue.$toast.error(response.data.message || 'Failed to load timesheet', { position: 'top' });
                        return;
                    }
                    let res = response.data.data;
                    console.log("AddTimesheetModal response:", res);

                    self.pastDateStart = res.period_start;
                    self.pastDateEnd = res.period_end;

                    self.initDate.inStart = moment(res.period_start)
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");

                    self.initDate.inEnd = moment(res.period_end)
                        .add(1, "days")
                        .format("YYYY-MM-DD");

                    self.initDate.outStart = res.period_start;

                    self.initDate.outEnd = moment(res.period_end)
                        .add(2, "days")
                        .format("YYYY-MM-DD");

                    self.task_option = [];

                    if (Array.isArray(res.task_select)) {
                        res.task_select.forEach(function (d) {
                            self.task_option.push({
                                text: d.value,
                                value: d.id
                            });
                        });
                    }

                    axios.get(self.constants.api_url + "jobs-status-input-ajax", header)
                        .then(function (response2) {


                            let jobs = [];

                            if (Array.isArray(response2.data.data)) {
                                response2.data.data.forEach(function (d) {
                                    jobs.push({
                                        id: d.job_id,
                                        value: d.description.toString().substring(2) + " - " + d.title
                                    });
                                });
                            }

                            localStorage.setItem(
                                "jobs_status_json",
                                JSON.stringify(jobs)
                            );

                            self.job_option = jobs;
                        });

                })
                .catch(function (err) {

                    Vue.$toast.error(err.message, {
                        position: "top"
                    });

                });
        },
        saveTimesheet() {
            if (this.isSaved) return;
            let self = this;

            let header = {
                headers: {
                    'Content-type': 'application/json',
                    token: localStorage.getItem('token')
                }
            };

            let flag = 1;

            if (self.timesheetData.job == '') {
                Vue.$toast.error('Please select a job', {
                    position: 'top'
                });

                return;
            }

            if (self.timesheetData.category == '') {
                Vue.$toast.error('Please select a Task Category', {
                    position: 'top'
                });

                return;
            }

            let job_option_status = false;

            for (var job of self.job_option) {
                if (job.id == self.timesheetData.job) {
                    job_option_status = true;
                    break;
                }
            }

            if (!job_option_status) {
                Vue.$toast.error('Invalid job selected', {
                    position: 'top'
                });

                return;
            }

            let dur = moment.duration(
                moment(self.timesheetData.timeOut).diff(
                    moment(self.timesheetData.timeIn)
                )
            );

            let total = dur.asHours().toFixed(2);

            total = (
                total -
                self.timesheetData.break / 60
            ).toFixed(2);

            if (total < 0) {
                Vue.$toast.error('Invalid Break, Must be Positive.', {
                    position: 'top'
                });

                return;
            }

            if (
                moment(self.timesheetData.timeOut).isAfter(moment())
            ) {
                Vue.$toast.error('Can not enter time in the future', {
                    position: 'top'
                });

                return;
            }

            let request = [];

            request.push({
                date_in: moment(self.timesheetData.timeIn).format(
                    'YYYY-MM-DD HH:mm:ss'
                ),

                date_out: moment(self.timesheetData.timeOut).format(
                    'YYYY-MM-DD HH:mm:ss'
                ),

                break:
                    self.timesheetData.break == ''
                        ? 0
                        : self.timesheetData.break,

                total: self.timesheetData.totalHour,

                job_id: self.timesheetData.job,

                task: self.timesheetData.category,

                user_id: JSON.parse(localStorage.getItem('userData')).id,

                description: self.timesheetData.description,

                rework_check:
                    self.timesheetData.rework.length != 0
                        ? 'on'
                        : '0'
            });

            let postData = {
                timesheet_data: request,
                pwa_flag: 1,
                page_name: this.pageName,
                user_id: JSON.parse(localStorage.getItem('userData')).id
            };

            this.isSaved = true;
            this.$emit('saving', true);
            this.validateLineupAssignmentBeforeCreate(
                postData,
                header
            );
        },

        validateLineupAssignmentBeforeCreate(postData, header) {
            let self = this;

            axios
                .post(
                    this.constants.api_url +
                    'timesheet/validate-lineup-assignment',
                    postData,
                    header
                )
                .then(function (res) {
                    const hasConflicts =
                        res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.has_conflicts;

                    if (hasConflicts) {
                        self.pendingCreatePostData = postData;
                        self.showAssignmentWarningPopup = true;
                        return;
                    }

                    self.submitCreateTimesheet(postData, header);
                })
                .catch(function () {
                    self.submitCreateTimesheet(postData, header);
                });
        },

        submitCreateTimesheet(postData, header) {
            let self = this;

            axios
                .post(
                    this.constants.api_url + 'timesheet/create',
                    postData,
                    header
                )
                .then(function (res) {
                    if (res.data.flag !== true) {
                        Vue.$toast.error(res.data.message || 'Failed to save timesheet', {
                            position: 'top'
                        });
                        return;
                    }

                    Vue.$toast.success('Timesheet Created', {
                        position: 'top'
                    });

                    // only change from original page
                    self.$emit('saving', false);
                    self.$emit('saved');

                })
                .catch(function (e) {
                    Vue.$toast.error((e && e.response && e.response.data && e.response.data.message) || e.message || 'Unable to save timesheet', {
                        position: 'top'
                    });
                })
                .finally(function () {
                    self.isSaved = false;
                    self.$emit('saving', false);
                });
        },
        continueAfterAssignmentWarning() {
            const header = {
                headers: {
                    'Content-type': 'application/json',
                    token: localStorage.getItem('token')
                }
            };

            this.showAssignmentWarningPopup = false;

            if (this.pendingCreatePostData) {
                const postData = this.pendingCreatePostData;
                this.pendingCreatePostData = null;

                this.submitCreateTimesheet(postData, header);
            }
        },

        cancelAssignmentWarning() {
            this.showAssignmentWarningPopup = false;
            this.pendingCreatePostData = null;
            this.isSaved = false;
            this.$emit('saving', false);
        },

        calculateTotalHours() {
            let self = this;

            if (/\D/g.test(self.timesheetData.break)) {
                self.timesheetData.break =
                    self.timesheetData.break.replace(/\D/g, '');
            }

            let dur = moment.duration(
                moment(self.timesheetData.timeOut).diff(
                    moment(self.timesheetData.timeIn)
                )
            );

            let total = dur.asHours().toFixed(2);

            let tmp = total - (self.timesheetData.break / 60);

            self.timesheetData.totalHour = tmp.toFixed(2);
        },

        selectedJob(query) {
            this.timesheetData.job = query.id.toString();
        }

    }
}
</script>

<style>
.assignment-warning-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1200;
}

.assignment-warning-modal {
    background: #fff;
    border-radius: 8px;
    width: 92%;
    max-width: 460px;
    padding: 20px;
}

.assignment-warning-modal h3 {
    margin: 0 0 10px;
}

.assignment-warning-modal p {
    margin: 0;
}

.assignment-warning-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
}
</style>
